import classes from './NavBar.module.css';
import NavLinks from './NavLinks';
import { IconContext } from 'react-icons';
import { FaXTwitter, FaInstagram, FaThreads, FaPinterestP } from 'react-icons/fa6';
import { COMPANY, URL_IN, URL_TW, URL_TH, URL_PI } from '../../Const';

/** 720px 以下で開くドロワー。リンク・電話番号・SNS を収める。 */
const MobileNavigation = ({ onNavigate }) => {
  return (
    <div className={classes.Drawer}>
      <NavLinks animate onNavigate={onNavigate} />
      <a className={classes.DrawerTel} href={`tel:${COMPANY.tel}`}>
        お電話でのご相談
        <b>{COMPANY.tel}</b>
      </a>
      <div className={classes.Sns}>
        <IconContext.Provider value={{ size: '24px' }}>
          <a href={URL_IN} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href={URL_TH} target="_blank" rel="noopener noreferrer" aria-label="Threads">
            <FaThreads />
          </a>
          <a href={URL_TW} target="_blank" rel="noopener noreferrer" aria-label="X">
            <FaXTwitter />
          </a>
          <a href={URL_PI} target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
            <FaPinterestP />
          </a>
        </IconContext.Provider>
      </div>
    </div>
  );
};

export default MobileNavigation;
